import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconShareProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconShare: React.FC<IconShareProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Share',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="18" cy="5" r="3" strokeWidth="2" />
            <circle cx="6" cy="12" r="3" strokeWidth="2" />
            <circle cx="18" cy="19" r="3" strokeWidth="2" />
            <path d="m8.59 13.51 6.83 3.98M15.41 6.51l-6.82 3.98" strokeWidth="2" strokeLinecap="round" />
        </svg>
    </IconBase>
);

export default IconShare;
